import Address from "../../../address/address.vue";

export default {
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value) {
        const reg = /^1\d{10}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      activeAddr: "first",
      list: [],
      list2: [],
      index: 0,
      pageNum: 1,
      pageShow: false,
      pageTotal: 0,
      searchVal: "",
      addressVisible: false,
      addSelfVisible: false,
      isSelfEdit: false,
      selfForm: {
        selfName: "",
        selfTel: "",
      },
      rules: {
        selfName: [{ required: true, message: "请输入自提人姓名", trigger: "blur" }],
        selfTel: [
          {
            required: true,
            message: "请输入自提人手机号",
            trigger: "blur",
          },
          { validator: checkPhone, trigger: "blur" },
        ],
      },
    };
  },

  components: {
    Address,
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      const { pageNum, searchVal } = this;
      this.$store
        .dispatch(
          "shop/shop/listCustomer",
          this.$qs.stringify({
            name: isNaN(Number(searchVal)) || (!isNaN(Number(searchVal)) && searchVal.length < 11) ? searchVal : "",
            phone: !isNaN(Number(searchVal)) && searchVal.length === 11 ? searchVal : "",
            groupId: "",
            pageNum,
            pageSize: 10,
          })
        )
        .then((res) => {
          const { count = 0, data = [] } = res;

          this.list = data;
          this.pageTotal = count;

          if (count > 0) {
            const boIds = data.map((item) => item.targetIdStr).join(",");
            this.$store.dispatch("scm/queryDelivery", this.$qs.stringify({ boIds })).then((data2 = []) => {
              const list2 = [];
              data.forEach((item) => {
                const arr = data2.filter((item2) => item.targetIdStr === item2.boIdStr);
                let addr = arr && arr.length ? arr[0] : {};
                addr = {
                  ...addr,
                  activeAddr: "addr",
                  isCustom: addr.isCustom || 0,
                  isSelfCustom: addr.isSelfCustom || 0,
                };
                list2.push(addr);
              });
              this.list2 = list2;
              console.log("地址列表", list2);
              this.pageShow = true;
            });
          }
        });
    },

    // 搜索
    search() {
      this.loadData();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.loadData();
    },

    // 修改状态
    receiveChange(index, arg) {
      const { list = [], list2 = [] } = this;
      const { addr, value, isCustom, areaId, areaAxis, name, tel, selfName, selfTel, isSelfCustom, activeAddr } = list2[index];
      this.$store
        .dispatch(
          "scm/updateDelivery",
          this.$qs.stringify(
            arg
              ? arg
              : {
                  tel,
                  addr,
                  boId: list[index].targetIdStr,
                  name,
                  value,
                  areaId,
                  areaAxis,
                  isCustom,
                  selfName,
                  selfTel,
                  isSelfCustom,
                }
          )
        )
        .then((res) => {
          const { code, msg } = res;
          if (code === "0") {
            this.$message.success("更新成功！");
            this.$store.dispatch("scm/queryDelivery", this.$qs.stringify({ boIds: list[index].targetIdStr })).then((data) => {
              let item = data[0] || {};
              item = {
                ...item,
                activeAddr,
              };
              this.$set(this.list2, index, item);
              this.addressVisible = false;
            });
          } else {
            this.$message.warning(msg);
          }
        });
    },

    // 修改自定义地址
    addressChange(index, type) {
      this.index = index;
      if (type === "self") {
        const { selfName, selfTel } = this.list2[index];
        this.isSelfEdit = selfName ? false : true;
        this.selfForm = {
          selfName: selfName || "",
          selfTel: selfTel || "",
        };
        this.addSelfVisible = true;
      } else {
        this.addressVisible = true;
      }
    },

    // 修改自定义地址确定
    addressConfirm(form, $form) {
      const { value, list, index } = this;
      this.receiveChange(index, {
        boId: list[index].targetIdStr,
        value,
        isCustom: 1,
        ...form,
      });
      $form.resetFields();
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { selfForm, list2, index } = this;
          const newAddr = {
            ...list2[index],
            ...selfForm,
            isSelfCustom: 1,
          };
          this.$set(this.list2, index, newAddr);
          this.receiveChange(index);
          this.resetForm(formName);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.addSelfVisible = false;
    },
  },
};
